import React, { useEffect, useContext } from "react";
import { CallAPI } from "services/API";
import { DeviceContext } from 'utils/Device/DeviceContext';
import TableWithContainer from "utils/Table/TableWithContainer";
import TooltipButton from "utils/TooltipButton/TooltipButton";

export default function QuotesByCoverageTypeAdvanced(props) {
    const device = useContext(DeviceContext);
    const integer = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const decimal = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const percent = new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    const currency = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });

    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const GetData = async () => {
        const response = await CallAPI("POST", "/Advanced/GetQuotesByCoverageType", {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city,
            groupBy: props.groupBy
        });

        if (response) {
            const formattedResponse = response.map((row) => [
                row.groupBy,
                integer.format(row.liabilityOnlyQuotes),
                percent.format(row.liabilityOnlyPercentage / 100),
                currency.format(row.liabilityOnlyAvgPremium),
                decimal.format(row.liabilityOnlyAvgVehicles),
                percent.format(row.liabilityOnlyBindPercentage / 100),
                integer.format(row.collCompQuotes),
                percent.format(row.collCompPercentage / 100),
                currency.format(row.collCompAvgPremium),
                decimal.format(row.collCompAvgVehicles),
                percent.format(row.collCompBindPercentage / 100),
                integer.format(row.compOnlyQuotes),
                percent.format(row.compOnlyPercentage / 100),
                currency.format(row.compOnlyAvgPremium),
                decimal.format(row.compOnlyAvgVehicles),
                percent.format(row.compOnlyBindPercentage / 100),
            ]);

            setData(formattedResponse);
        }

        setLoading(false);
    };

    useEffect(() => {
        if (props.call === "true" || props.call === null) {
            GetData();
            setLoading(true);
        }
    }, [props.call]);

    return (
        <div>
            <TableWithContainer
                title={"QUOTES BY COVERAGE TYPE"}
                exportName="QuotesByCoverageType"
                loading={loading}
                rowsPerPage={32}
                fixedColumns={1}
                style={{
                    Title: { lineHeight: "1em", fontSize: device.isMobile ? "1.3em" : "2.5em" },
                    Table: {
                        Header: { minWidth: "96px" }
                    }
                }}
                headers={[
                    [
                        { text: props.groupBy, rowspan: 2 },
                        {
                            text: (<h5 style={{ margin: 0 }}><b>Liability Only</b><TooltipButton tooltipText={"Quotes in which comp/coll not present on any vehicles"} /></h5>),
                            colspan: 5, style: { width: "auto", textAlign: "center" }
                        },
                        {
                            text: (<h5 style={{ margin: 0 }}><b>Coll/Comp</b><TooltipButton tooltipText={"Quotes where at least one vehicle has comp/coll"} /></h5>),
                            colspan: 5, style: { width: "auto", textAlign: "center", borderLeft: "solid thin" }
                        },
                        {
                            text: (<h5 style={{ margin: 0 }}><b>Comp Only</b><TooltipButton tooltipText={"Quotes where at least one vehicle has comp only, if one vehicle has comp/coll and the other has liability only, it'll be under comp/coll"} /></h5>),
                            colspan: 5, style: { width: "auto", textAlign: "center", borderLeft: "solid thin" }
                        },
                    ],
                    [
                        "Quotes", "%", "Avg Prem", "Avg Vehicles", "Bind %",
                        "Quotes", "%", "Avg Prem", "Avg Vehicles", "Bind %",
                        "Quotes", "%", "Avg Prem", "Avg Vehicles", "Bind %"
                    ]
                ]}
                rows={data.filter(x => x[0] !== "Total")}
                footers={data.filter(x => x[0] === "Total")}
            />
        </div>
    );
};